















































import Vue from "vue";

export default Vue.extend({
  name: "Softway",

  data: () => ({
    items: [
      {
        title: "experiences.thales.edf.title",
        description: "experiences.thales.edf.description",
        details: [
          "details.angular",
          "details.typescript",
          "details.cordova",
          "details.yeoman",
          "details.java",
          "details.git",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.boiron.title",
        description: "experiences.thales.boiron.description",
        details: [
          "details.java",
          "details.swing",
          "details.angularjs",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.biomerieux.title",
        description: "experiences.thales.biomerieux.description",
        details: [
          "details.java",
          "details.swing",
          "details.gwt",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.sncf.title",
        description: "experiences.thales.sncf.description",
        details: [
          "details.java",
          "details.mdm",
          "details.xsd",
          "details.oracle",
          "details.scrum"
        ]
      },
      {
        title: "experiences.thales.orange.title",
        description: "experiences.thales.orange.description",
        details: [
          "details.java",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.wicket",
          "details.ajax",
          "details.scrum"
        ]
      }
    ]
  })
});
